import { DEVICES_PATH } from 'distributions/navigation';

module.exports = {
  path: DEVICES_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DistributionDevices'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/distributions/routes/show/routes/devices/index.js